export async function IsBrowserARCompatible(): Promise<boolean> {
    if (window.navigator.xr) {
      const isSupported: boolean = await window.navigator.xr.isSessionSupported("immersive-ar",);
      console.info(`[DEBUG] ${isSupported ? "Browser supports immersive-ar" : "Browser does not support immersive-ar"}`,);
      return isSupported;
    }
    return false;
}